import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Fab from '@mui/material/Fab'
import {findGlobalIndex} from './utils'
 
const useStyles = makeStyles(linkStyles)

export default function QuestionLink ({section, sections, context, question, index}) {

  const classes = useStyles()
  const {results = {}} = context.quizAssessmentToReview
  const result = results[question.id] || {}

  const selected = question.id == context.questionId && section.id == context.sectionId

  const reviewNeeded = result.pending == true
  const correct = result.points > 0 && !reviewNeeded

  const onClick = e => selected && e.preventDefault()
  const className = clsx(classes.root, {selected, correct, reviewNeeded})
  const href = '#' + context.link({sectionId: section.id, questionId: question.id}) 

  const globalIndex = findGlobalIndex(question.id, sections)

  return (
    <Fab {...{size: 'small', onClick, className, href}}>
      {reviewNeeded ? 'R' : globalIndex + 1}
    </Fab>
  )
}

export function QuestionLinkDummy () {
  const classes = useStyles()
  return (
    <Fab size="small" className={clsx(classes.root, "dummy")}>0</Fab>
  )
}

function linkStyles (theme) {
  return {
    root: {
      backgroundColor: '#f41822',
      color: '#fff',
      boxShadow: 'none',
      marginRight: 10,
      "& .MuiFab-label": {
        paddingTop: 2
      },
      "&:last-child": {
        marginRight: 0
      },
      "&.dummy": {
        visibility: 'hidden'
      },
      "&.reviewNeeded": {
        border: 'solid 1px #f41822',
        color: '#f41822',
        backgroundColor: '#fff'
      },
      "&.correct": {
        backgroundColor: '#52aa5e',
        color: '#fff',
      },
      "&.selected": {
        backgroundColor: '#000',
        color: '#fff',
        cursor: 'default'
      }
    }
  }
}
